import { useState } from "react"
import { Employee } from "../../Objects/Employee/Employee"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"

export const useCreateEmployee = (isMaster: boolean) => {
  const [username, setUsername] = useState("")

  const [password, setPassword] = useState("")

  const [salaryFixed, setSalaryFixed] = useState("")

  const [percentCommission, setPercentCommission] = useState("")

  const [companyFunction, setCompanyFunction] = useState("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [employee, settEmployee] = useState<Employee | null>(null)

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)
  const handleSalaryFixedChange = (e: React.ChangeEvent<HTMLInputElement>) => setSalaryFixed(e.target.value)
  const handlePercentCommissionChange = (e: React.ChangeEvent<HTMLInputElement>) => setPercentCommission(e.target.value)
  const handleCompanyFunctionChange = (e: React.ChangeEvent<HTMLInputElement>) => setCompanyFunction(e.target.value)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (employee: Employee | null | undefined) => {
    if (employee) {
      settEmployee(employee)
      setPassword(employee.password)
      setSalaryFixed(employee.salaryFixed)
      setPercentCommission(employee.percentCommission)
      setCompanyFunction(employee.companyFunction)
      setStatus(employee.status)
    }
  }

  const handleSubmitForm = () => {
    return new Employee({
      status: status,
      employeeId: employee?.employeeId,
      password: password,
      salaryFixed: salaryFixed,
      percentCommission: percentCommission,
      isMaster: isMaster,
      companyFunction: companyFunction,
      userName: username,
    })
  }

  return {
    status,
    password,
    salaryFixed,
    percentCommission,
    companyFunction,
    username,
    handleUsernameChange,
    handleStatusChange,
    handlePasswordChange,
    handleSalaryFixedChange,
    handlePercentCommissionChange,
    handleCompanyFunctionChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
